module.exports = __webpack_public_path__ + "img/faucet.2a10a37c.svg";